const DUMMY_M = ['m-0', 'm-1', 'm-2', 'm-3', 'm-4', 'm-5', 'm-6', 'm-7', 'm-8', 'm-9', 'm-10'].map((item, index) => <option key={index} value={item}>{item}</option>)
const DUMMY_MY = ['my-0', 'my-1', 'my-2', 'my-3', 'my-4', 'my-5', 'my-6', 'my-7', 'my-8', 'my-9', 'my-10'].map((item, index) => <option key={index} value={item}>{item}</option>)
const DUMMY_MX = ['mx-0', 'mx-1', 'mx-2', 'mx-3', 'mx-4', 'mx-5', 'mx-6', 'mx-7', 'mx-8', 'mx-9', 'mx-10'].map((item, index) => <option key={index} value={item}>{item}</option>)
const DUMMY_MT = ['mt-0', 'mt-1', 'mt-2', 'mt-3', 'mt-4', 'mt-5', 'mt-6', 'mt-7', 'mt-8', 'mt-9', 'mt-10'].map((item, index) => <option key={index} value={item}>{item}</option>)
const DUMMY_MB = ['mb-0', 'mb-1', 'mb-2', 'mb-3', 'mb-4', 'mb-5', 'mb-6', 'mb-7', 'mb-8', 'mb-9', 'mb-10'].map((item, index) => <option key={index} value={item}>{item}</option>)

const Margin = props => {
    return <div className="container fluid py-2" id="margin">

        <div className="container fluid">
            <p className="text xl"><a href="#margin" className="link">&#128279;</a> Margin</p>
            <p className="text md">
                Margin applies specific margin to an element defined in percentages.
        </p>
        </div>


        <div className="spacer md"></div>

        <div className="container lg">
            <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>
                            <th>Description</th>
                            <th>Select</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <code>.m-0, .m-1, .m-2, .m-3, .m-4, .m-5, .m-6, .m-7, .m-8, .m-9, .m-10</code>
                            </td>
                            <td>Sets the margin on all sides of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the margin</label>
                                    <select onChange={(e) => props.helper('margin-display', '', `h25 bg-primary`, e)}>
                                        {DUMMY_M}
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.my-0, .my-1, .my-2, .my-3, .my-4, .my-5, .my-6, .my-7, .my-8, .my-9, .my-10</code>
                            </td>
                            <td>Sets the margin on top & bottom sides of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the margin</label>
                                    <select onChange={(e) => props.helper('margin-display', '', `h25 bg-primary`, e)}>
                                        {DUMMY_MY}
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.mx-0, .mx-1, .mx-2, .mx-3, .mx-4, .mx-5, .mx-6, .mx-7, .mx-8, .mx-9, .mx-10</code>
                            </td>
                            <td>Sets the margin on left & right sides of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the margin</label>
                                    <select onChange={(e) => props.helper('margin-display', '', `h25 bg-primary`, e)}>
                                        {DUMMY_MX}
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.mt-0, .mt-1, .mt-2, .mt-3, .mt-4, .mt-5, .mt-6, .mt-7, .mt-8, .mt-9, .mt-10</code>
                            </td>
                            <td>Sets the margin on top side of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the margin</label>
                                    <select onChange={(e) => props.helper('margin-display', '', `h25 bg-primary`, e)}>
                                        {DUMMY_MT}
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.mb-0, .mb-1, .mb-2, .mb-3, .mb-4, .mb-5, .mb-6, .mb-7, .mb-8, .mb-9, .mb-10</code>
                            </td>
                            <td>Sets the margin on bottom side of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the margin</label>
                                    <select onChange={(e) => props.helper('margin-display', '', `h25 bg-primary`, e)}>
                                        {DUMMY_MB}
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="container sm my-2 border-dark">
            <div className="bg-primary h25" id="margin-display"></div>
        </div>


    </div>
}

export default Margin